
import React, {MouseEvent} from "react";
import { HttpsRequest, GetAuth, Alerts } from '../component/Utils';
import MenuComp, { PageTitle } from "../component/menucomp";
import Pagination from "../component/Paginator";
import { URLENUM, MSG } from "../component/Texts";
import { Loading, ActionBar, BoxArea } from "../component/BaseComponent";
import { FaRoad } from "react-icons/fa";



type ReportUIProp = {
}

type ReportDataProp = {
    id: number;
    date: string;
    device_id: string;
    asset_type: string;
    asset_id: string;
    distance: string;
    stops?: number;
    vehicle_name: string;
}


type ReportUIState = {
    body: ReportDataProp[];
    isbusy: boolean;
    pager: {
        next_page: number;
        page: number;
        pages: number[];
        prev_page: number;
        total: number;
        rows: number;
    },
    trips_data: Record<string, string>[];
}

class ReportUI extends React.Component<ReportUIProp, ReportUIState> {

    constructor(props: ReportUIProp) {
        super(props);
        this.state = {
            body: [],
            isbusy: true,
            pager: {
                next_page: 0,
                page: 1,
                pages: [],
                prev_page: 0,
                total: 0,
                rows: 10
            },
            trips_data: []
        }
    }

    render() {

        return (
            <div>
                <MenuComp />
                <br /> <br />

                <ActionBar
                    search={true} 
                    classname={'col-md-8'}
                    placeholder={"search by asset type"}
                />
                <br />
                <div className="container-fluid">
                    <div className="row">
                        <BoxArea classname={"col-md-7"}>
                            <PageTitle title={'Movement Report Summary'} />
                            <div className='table-responsive posrel'>
                                <table className="table table-condensed table-striped table-hover mb-5">
                                    <thead>
                                        <tr>
                                            <td> Date </td>
                                            <td> Tracker Serial No </td>
                                            <td> Name </td>
                                            <td> Asset Type </td>
                                            <td> Asset Id </td>
                                            <td> Distance Covered (KM)  </td>
                                            <td colSpan={2}> Aproximate Stops </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.body.length === 0 ? <tr> <td colSpan={8}> <i> no data found...</i></td> </tr> : (
                                                this.state.body.map((item, idx) => <ReportRows func={this.get_trip_detail} item={item} key={`rp-${idx}`} />)
                                            )
                                        }
                                    </tbody>
                                </table>
                                <Pagination {...this.state.pager} navigate={this.refresh_page} />

                                {this.state.isbusy && <Loading />}
                            </div>
                        </BoxArea>
                        {
                            this.state.trips_data.length  == 0? null : (
                                <BoxArea classname="col-md-5">
                                    <PageTitle title={"Trip Routes"} />
                                    <div style={{maxHeight: "700px", overflowY:"auto"}}> 
                            
                                        {
                                            this.state.trips_data.map( (trip, idx) => {
                                                
                                                if (trip.title == 'start point'){
 
                                                    return (
                                                        <div className="position-relative mb-4 animate-item" style={{"animationDelay": "0.1"}}>                                                                                                                                                                                              
                                                            <div className="card border-light rounded-4 shadow-sm h-100 transition-shadow">
                                                                <div className="card-body p-3">
                                                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                                                        <div>
                                                                            <h3 className="h6 fw-bold mb-0"> {trip.title}</h3>
                                                                            <p className="small text-muted mt-1 mb-0 d-flex align-items-center gap-1">
                                                                                <i className="ph ph-map-pin"></i> {trip.address}
                                                                            </p>
                                                                        </div>
                                                                        <div className="text-end">
                                                                            <span className="badge bg-light text-dark border d-inline-flex align-items-center gap-1 p-2">
                                                                                <i className="ph ph-clock text-secondary"></i>
                                                                                <a href={`https://www.google.com/maps/search/${trip.latlng}`} target="_blank"> {trip.latlng } </a>
                                                                            </span>
                                                                        </div>
                                                                    </div> 
                                                                    <div className="mt-3 pt-3 border-top d-flex justify-content-between align-items-center" style={{fontSize: "0.75rem"}}>
                                                                        <div className="text-secondary">
                                                                            {trip.latlng}
                                                                        </div>
                                                                        <div className="text-secondary fw-medium">Starting Point</div> 
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                }

                                                return ( 
                                                    <div className="position-relative mb-4 animate-item" style={{"animationDelay": "0.1"}}>       
                                                            <div className="card border-light rounded-4 shadow-sm h-100 transition-shadow">
                                                                <div className="card-body p-3">
                                                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                                                        <div>
                                                                            <h3 className="h6 fw-bold mb-0"> {trip.title}</h3>
                                                                            <p className="small text-muted mt-1 mb-0 d-flex align-items-center gap-1">
                                                                                <i className="ph ph-map-pin"></i> {trip.address}
                                                                            </p>
                                                                        </div>
                                                                        <div className="text-end">
                                                                            <span className="badge bg-light text-dark border d-inline-flex align-items-center gap-1 p-2">
                                                                                <i className="ph ph-clock text-secondary"></i>
                                                                                {trip.time}
                                                                            </span>
                                                                        </div>
                                                                    </div> 
                                                                    <div className="mt-3 pt-3 border-top d-flex justify-content-between align-items-center" style={{fontSize: "0.75rem"}}>
                                                                        <div className="text-secondary">                                                                            
                                                                            <a href={`https://www.google.com/maps/search/${trip.latlng}`} target="_blank"> {trip.latlng } </a> &nbsp;  {trip.distance_covered}
                                                                        </div>
                                                                        {
                                                                            trip.title === 'Return Trip'? null : (
                                                                            <div className="d-flex align-items-center gap-1 text-primary fw-medium bg-primary bg-opacity-10 px-2 py-1 rounded-pill">
                                                                                <i className="ph-bold ph-car-profile"></i>
                                                                                {trip.time_elapsed}  elasped
                                                                            </div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                            )}
                                            )
                                        }
                                    </div>

                                    <button className="btn btn-default" onClick={this.close_detail_display}> Close </button>
                                </BoxArea>
                            )
                        }                  

                    </div>
                </div>

            </div>
        )
    }
    close_detail_display = (evt: MouseEvent<HTMLButtonElement>) => {

        evt.preventDefault()

        this.setState({
            trips_data: []
        })
    }
    get_trip_detail = (event: MouseEvent<HTMLAnchorElement>, fid:number) => {
        
        event.preventDefault();
        console.log(event, fid);

        const callback = (resp:callbackType) => {
            

            if (resp.status === -1) {
                Alerts.show_error(resp.errormsg || MSG.APP_ERROR);
                this.setState({
                    isbusy: false 
                })             
                return false
            }

            const { trips } = resp.body;
            this.setState({
                isbusy: false,
                trips_data: trips
            })

        }

        HttpsRequest.get(URLENUM.report + "details/" + fid,
            callback,
            GetAuth()
        )
        this.setState({isbusy: true});

    }

    componentDidMount() {

        HttpsRequest.get(URLENUM.report,
            this.fetch_callback,
            GetAuth()
        )
    }

    fetch_callback = (resp: callbackType) => {

        if (resp.status === -1) {
            Alerts.show_error(resp.errormsg || MSG.APP_ERROR)
            this.setState({
                isbusy: false
            })
            return false
        }

        const { reports, pager } = resp.body;

        this.setState({
            body: reports,
            isbusy: false,
            pager: {
                page: pager.page,
                pages: pager.pages,
                prev_page: pager.prev_page,
                total: pager.total,
                next_page: pager.next_page,
                rows: this.state.pager.rows
            }
        });

    }

    refresh_page = (page: number, rows?: string) => {
        HttpsRequest.get(
            URLENUM.report,
            this.fetch_callback, GetAuth(),
            { 'page': String(page), "rows": rows || '10' }
        )
        const { pager } = this.state
        pager.rows = rows ? Number(rows) : 10
        this.setState({ isbusy: true, pager: pager });
    }
}


function ReportRows({ item, func }: { item: ReportDataProp, func: (evt: any, fid:number)=>void }) {

    let approx_distance = Math.round((Number(item.distance) + 0.00001) * 100) / 100;

    return (
        <tr>
            <td> {item.date} </td>
            <td> {item.device_id} </td>
            <td> {item.vehicle_name} </td>
            <td> {item.asset_type} </td>
            <td> {item.asset_id} </td>
            <td> {approx_distance} KM </td>
            <td> {item.stops} </td>
            <td> <a href="#" className="btn btn-info btn-sm" 
                onClick={(evt)=>func(evt, item.id)}> View Trip <FaRoad size={15} /> </a></td>
        </tr>
    )

}


export default ReportUI

